import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, ArrowRight } from 'lucide-react';
import { CURRENT_GIFT_CHAPTER } from '../data/gift-chapter';

/**
 * Promotional card for the monthly free chapter gift.
 * Drop on any Village page (Threshold, Welcome, About, Daily, etc.).
 *
 * Props:
 *   compact — boolean (default false). True = horizontal layout for blog grids.
 */
export default function GiftPromoCard({ compact = false }) {
  const meta = CURRENT_GIFT_CHAPTER;

  return (
    <Link
      to="/gift"
      className={`gpc ${compact ? 'gpc--compact' : ''}`}
      data-testid="gift-promo-card"
    >
      <div className="gpc-glow" aria-hidden="true" />
      <div className="gpc-cover-wrap">
        <img src={meta.bookCover} alt="" className="gpc-cover" loading="lazy" />
      </div>
      <div className="gpc-text">
        <span className="gpc-badge">
          <Gift size={12} strokeWidth={2.2} /> {meta.month} · Free Gift
        </span>
        <h3 className="gpc-title">Get this month's free chapter</h3>
        <p className="gpc-sub">
          {meta.title} — a free preview from Cabrini's book F.U.C.K. T.H.A.T.T.
        </p>
        <span className="gpc-cta">
          Claim your gift <ArrowRight size={14} strokeWidth={2.2} />
        </span>
      </div>
    </Link>
  );
}
